import { render, staticRenderFns } from "./ProfileParticipants.vue?vue&type=template&id=57842538"
import script from "./ProfileParticipants.vue?vue&type=script&lang=js"
export * from "./ProfileParticipants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports